<template>
  <v-dialog v-if="dialog" v-model="dialog" :max-width="width" persistent>
    <SDialog
      title="Modifier un capteur"
      :icon="mainIcon"
      :loading="loading"
      @onClose="closeDialog"
    >
      <template v-slot:content-dialog>
        <form @submit.prevent="update()" class="form-login">
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <STextField
                label="MAC Adresse"
                v-model="sensor.macAddress"
                icon="fa-at"
                readonly
                disabled
              />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <STextField
                label="Nom capteur"
                v-model="sensor.nickname"
                icon="fa-microchip"
                :error-messages="
                  $fieldValidator('Nom Capteur', $v.sensor.nickname)
                "
                @input="$v.sensor.nickname.$touch()"
                @blur="$v.sensor.nickname.$touch()"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-autocomplete
                label="Mode"
                prepend-icon="fa-wifi"
                color="primaryColor"
                v-model="sensor.connectionType"
                :items="['BLE', 'LORA']"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="8">
              <STextField
                label="Endroit"
                v-model="sensor.place"
                icon="fa-location-dot"
              />
            </v-col>
            <v-col v-if="user.userType == 'ADMIN'" cols="12" sm="12" md="4">
              <v-autocomplete
                label="Fournisseur"
                prepend-icon="fa-bookmark"
                color="primaryColor"
                item-value="name"
                v-model="sensor.provider"
                :items="providers"
                outlined
              >
                <template v-slot:selection="{ item }">
                  {{ item.text }}
                  <v-spacer></v-spacer>
                  <v-img :src="item.img" max-width="40"></v-img>
                </template>

                <template v-slot:item="{ item }">
                  {{ item.text }}
                  <v-spacer></v-spacer>
                  <v-img :src="item.img" max-width="40"></v-img>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col v-if="user.userType == 'ADMIN'" cols="12" sm="12" md="8">
              <v-autocomplete
                label="Propriétaire"
                prepend-icon="fa-user-tie"
                item-value="uid"
                color="primaryColor"
                v-model="sensor.owner"
                :items="owners"
                outlined
              >
                <template v-slot:selection="{ item }">
                  {{ item.email }}
                  <v-spacer></v-spacer>
                  <v-chip text-color="white" color="success" small>
                    {{ item.name }}
                  </v-chip>
                </template>

                <template v-slot:item="{ item }">
                  {{ item.email }}
                  <v-spacer></v-spacer>
                  <v-chip text-color="white" color="success" small>
                    {{ item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </form>
      </template>
      <template v-slot:action-dialog>
        <SButton
          :loading="loading"
          :disabled="$v.$invalid"
          raised
          success
          @click="update()"
        >
          Modifier
        </SButton>
        <SButton raised error @click="closeDialog" color="error">
          Annuler
        </SButton>
      </template>
    </SDialog>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

import orangeProvider from "@/assets/icons/orange.png";
import objeniousProvider from "@/assets/icons/objenious.png";
import clientProvider from "@/assets/icons/client.gif";

export default {
  name: "SensorDialog",
  mixins: [validationMixin],
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    editedSensor: {
      type: Object,
      default: null,
    },
    width: {
      type: [Number, String],
      default: "60%",
    },
    mainIcon: {
      type: String,
    },
  },
  validations: {
    sensor: {
      nickname: {
        required,
        minLength: minLength(3),
      },
      macAddress: {
        required,
      },
    },
  },
  data: () => ({
    providers: [
      { name: "ORANGE", text: "Orange", img: orangeProvider },
      {
        name: "OBJENIOUS",
        text: "Objenious",
        img: objeniousProvider,
      },
      { name: "CLIENT", text: "Utilisateur", img: clientProvider },
    ],
    loading: false,
    owners: [],
    sensor: {
      macAddress: "",
      nickname: "",
      place: "",
      connectionType: "",
      provider: "",
      owner: null,
    },
  }),
  methods: {
    async update() {
      try {
        this.loading = true;
        await this.updateSensor(this.sensor);
        this.loading = false;
        return this.$emit("onUpdate");
      } catch ({ success, error }) {
        this.$emit("onErrors", { success, message: error });
        this.loading = false;
      }
    },
    closeDialog() {
      return this.$emit("closeDialog");
    },
    ...mapActions({
      retrieveUsers: "users/retrieveUsers",
      updateSensor: "sensors/updateSensor",
    }),
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      getUsers: "users/getUsers",
    }),
  },
  async created() {
    this.sensor = Object.assign({}, this.editedSensor);
    this.sensor.owner = this.editedSensor.owner || null;
    try {
      await this.retrieveUsers();
      this.owners = this.getUsers;
    } catch (error) {
      this.$emit("onErrors", { success, message: error });
    }
  },
};
</script>

<style></style>
